/**----------------------------------------------------------------------+
*
*   $Source: src/app/shared/cloud/cloud-name-storage.service.ts $
*
*  $Copyright: (c) 2020 Bentley Systems, Incorporated. All rights reserved. $
*
*----------------------------------------------------------------------*/
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CloudIsGovCloudStorageService {

  storageKey = "cloud_IsGovCloud";

  constructor() { }

  loadCloudIsGovCloud(): string {
    return localStorage.getItem(this.storageKey);
  }

  storeCloudIsGovCloud(IsGovCloud: boolean): void {
    localStorage.setItem(this.storageKey, IsGovCloud.toString());
  }

  clearCloudIsGovCloud(): void {
    localStorage.removeItem(this.storageKey);
  }
}
